import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import routesCodigo from "./codigo.router";
import routesValidador from "./validador.router";
import routesAdmin from "./admin.router";
import routesPuntos from "./puntos.router";
import routesRecompensa from "./recompensa.router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: () => {
      const lastRoute = Vue.localStorage.get("last_route");
      if (lastRoute) {
        return JSON.parse(lastRoute);
      }
      // Default a home de regalos si no hay última ruta
      return { name: "home" };
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue")
  },
  ...routesCodigo,
  ...routesValidador,
  ...routesAdmin,
  ...routesPuntos,
  ...routesRecompensa,
  // not found page
  {
    path: "/not-allowed",
    name: "not-allowed",
    component: () => import("../views/NotAllowed.vue")
  },
  {
    path: "*",
    name: "not-found",
    component: () => import("../views/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name !== "login" && !Vue.localStorage.get("token")) {
    next({ name: "login" });
  } else {
    if (to.name === "home") {
      store.commit("settings/SET_LOADING", true);
    }
    next();
  }
});

router.afterEach(to => {
  // Guardar la ruta actual (solo las rutas que tienen sidebar)
  if (to.meta && to.meta.sidebar) {
    store.commit("settings/SET_LAST_ROUTE", { name: to.name });
  }
});

export default router;
